import { render, staticRenderFns } from "./MessageProtectPopup.vue?vue&type=template&id=2bb65523&scoped=true"
import script from "./MessageProtectPopup.vue?vue&type=script&lang=ts"
export * from "./MessageProtectPopup.vue?vue&type=script&lang=ts"
import style0 from "./MessageProtectPopup.vue?vue&type=style&index=0&id=2bb65523&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb65523",
  null
  
)

export default component.exports